import { WithdrawalsReceiveGetListReducer } from './types';

export const withdrawalsReceiveGetListReducer: WithdrawalsReceiveGetListReducer =
  (state, action) => {
    const { items, totalCount } = action.payload;

    return {
      ...state,
      withdrawalsList: {
        items,
        totalCount,
      },
    };
  };
